import { render, staticRenderFns } from "./journaltable.vue?vue&type=template&id=168701d3&scoped=true&"
import script from "./journaltable.vue?vue&type=script&lang=js&"
export * from "./journaltable.vue?vue&type=script&lang=js&"
import style0 from "./journaltable.vue?vue&type=style&index=0&id=168701d3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168701d3",
  null
  
)

export default component.exports